import { useClient, useDictionary } from '@adamlip/okeoke.client';
import { AppParamsContext } from 'contexts/AppParamsContext';
import { UserContext } from 'contexts/UserContext';
import { QRCodeSVG } from 'qrcode.react';
import { useContext, useState } from 'react';
import ReactCardFlip from 'react-card-flip';

export default function VIPCard({ element }) {
  const { getName, brandID } = useClient();
  const { appParams } = useContext(AppParamsContext);
  const { getValue } = useDictionary();
  const { userData, isVipBrand } = useContext(UserContext);
  const [isFlipped, setIsFlipped] = useState(false);
  let defaultVipCardBgImgUrl = userData?.cardImageUrl || appParams?.assets?.vipBackgroundImg || `https://cdn.okeoke.io/brands/${brandID}/assets/vip_card_default.png`;

  if (!isVipBrand) return null;
  return (
    <div className='px-3'>
      <div className='w-full flex flex-row gap-2 items-center justify-between'>
        <div>{getName(element?.attributes?.label) && <p className='text-lg font-bold mb-2'>{getName(element?.attributes?.label)}</p>}</div>
        <div>
          {element?.attributes?.showAvailablePoints && (
            <p className='text-lg font-bold mb-2 text-primary'>
              {getValue('app_v2_vip_point_balance')}: {userData?.points || 0}
            </p>
          )}
        </div>
      </div>
      <div className='flip-card-div shrink-0 w-full px-2 items-center justify-center flex'>
        <ReactCardFlip isFlipped={isFlipped} flipDirection='vertical'>
          <div className="w-[400px] max-w-full m-auto cursor-pointer">
            <div className="aspect-ratio">
              <div
                onClick={() => setIsFlipped(!isFlipped)}
                className='vip-card-root animation-shine delay1 !bg-[--button-bg-color] h-full w-full z-10'
                style={
                  appParams?.vip?.vipCardBgType === '2'
                    ? {
                      backgroundImage: `url(${defaultVipCardBgImgUrl})`,
                    }
                    : {}
                }></div>
              <div
                onClick={() => setIsFlipped(!isFlipped)}
                className='vip-card-root animation-shine delay1 !bg-[--button-bg-color] h-full w-full'
                style={{
                  backgroundColor: appParams?.styles?.qrCode?.bgColor || '#FFFFFF',
                  color: appParams?.styles?.qrCode?.fgColor || '#000000',
                }}>
              </div>
            </div>
          </div>
          <div className="w-[400px] max-w-full m-auto cursor-pointer">
            <div className="aspect-ratio">
              <div className={`qr-root ${userData?.vipID == null ? 'blur-on' : 'blur-off'} w-full`} onClick={() => setIsFlipped(!isFlipped)}>
                <QRCodeSVG
                  value={userData?.vipID + ''}
                  includeMargin={true}
                  //renderAs='svg'
                  size={160}
                  level='H'
                  bgColor={appParams?.styles?.qrCode?.bgColor || '#FFFFFF'}
                  fgColor={appParams?.styles?.qrCode?.fgColor || '#000000'}
                />
                <div className='short-id font-large hidden-content appear'>{userData?.shortID}</div>
              </div>
            </div>
          </div>
        </ReactCardFlip>
      </div>
    </div>
  );
}
